export const paySettingsKeys = {
  all: ['paySettings'] as const,
  payingAccountForm: (companyId: string, accountId: string) =>
    [...paySettingsKeys.all, 'payingAccountForm', companyId, accountId] as const,
};
